import { render } from "./thank_you_configuration.html?vue&type=template&id=64e31d9c&external"
import script from "./thank_you_configuration.js?vue&type=script&lang=js&external"
export * from "./thank_you_configuration.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__